export default __webpack_public_path__ + "static/media/box-open.429017c1.svg";